import Link from 'next/link';
import { usePathname } from 'next/navigation';

const MENU_TABS = [
  {
    text: '履歴',
    url: '/pointhistory/usage',
  },
  {
    text: '付与予定',
    url: '/pointhistory/schedule',
  },
] as const;

export const MenuTabs: React.FC = () => {
  const pathname = usePathname();

  return (
    <div className="grid grid-cols-2 rounded-3 bg-main-10">
      {MENU_TABS.map((menuTab, index) => (
        <div className="p-1" key={index}>
          <Link
            href={menuTab.url}
            passHref
            className={
              pathname === menuTab.url
                ? 'block w-full rounded-2 bg-base-100 p-2 text-center text-base1 font-bold cst-halt leading-[1.4] text-main-100'
                : 'block w-full p-2 text-center text-base1 font-bold cst-halt leading-[1.4] text-main-100'
            }
          >
            {menuTab.text}
          </Link>
        </div>
      ))}
    </div>
  );
};
